import styled from "@emotion/styled";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { helpHttp } from "../../helper/helpHttp";
import { eliminarDiacriticosEs } from "../../utils/textConverter";
import { redeslink } from "./redeslinks";
import { useDispatch } from "react-redux";
import { changeLoading } from "../../redux/slices/category";
import Button from "@mui/material/Button";
import CachedIcon from "@mui/icons-material/Cached";

const CATEGORYID = "3";

const Redes = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [datalinks, setDataLinks] = useState(redeslink);
  const { get } = helpHttp();
  const [downloadingPdf, setDownloadingPdf] = useState(false);

  useEffect(() => {
    dispatch(changeLoading(true));
    get(`categorias/getDetailsCategoriaSinPdf/${CATEGORYID}`)
      .then((data) => {
        setData(data.datos);
      })
      .catch(() => toast.error("Ha ocurrido un error"))
      .finally(() => {
        dispatch(changeLoading(false));
      });
  }, []);

  const downloadPdf = (itemId, fileName) => {
    setDownloadingPdf(true);
    get(`categorias/getDetailCategoriaByIdDetail/${CATEGORYID}/${itemId}`)
      .then((response) => {
        const isMobile =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          ) || window.matchMedia("(pointer: coarse)").matches;

        if (isMobile) {
          const base64 = response.datos.url_pdf.split(",")[1]; // Quitar "data:application/pdf;base64,"
          const byteCharacters = atob(base64);
          const byteNumbers = new Array(byteCharacters.length)
            .fill()
            .map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });

          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else {
          const pdfData = response.datos.url_pdf;
          const pdfLink = document.createElement("a");
          pdfLink.href = pdfData;
          pdfLink.download = `${fileName}.pdf`;
          document.body.appendChild(pdfLink);
          pdfLink.click();
          document.body.removeChild(pdfLink);
        }
      })
      .catch(() => {
        toast.error("No se pudo abrir el PDF");
      })
      .finally(() => {
        setDownloadingPdf(false);
      });
  };

  return (
    <GridData>
      <StyledRedes>
        {data.map((e) => {
          return (
            <StyledCard key={e.id} id={eliminarDiacriticosEs(e.titulo, true)}>
              <StyledVideo>
                {e.url_video.trim() ? (
                  <iframe
                    width="100%"
                    height="100%"
                    src={e.url_video}
                    frameBorder="0"
                    loading="lazy"
                    allow="fullscreen; picture-in-picture"
                  />
                ) : (
                  <img
                    style={{ borderRadius: "3px" }}
                    width="100%"
                    src={e.imagen}
                  />
                )}
              </StyledVideo>
              <StyledInfo>
                <Typography component={"h3"} variant="title">
                  {e.titulo}
                </Typography>
                <div>
                  <Typography>{e.descripcion}</Typography>
                </div>

                {e.url_pdf && (
                  <Button
                    disabled={downloadingPdf}
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => downloadPdf(e.id, e.titulo)}
                    sx={{ marginTop: "15px", width: "max-content" }}
                    endIcon={
                      downloadingPdf ? (
                        <CachedIcon className="downloadingPdf" />
                      ) : (
                        <PictureAsPdfOutlinedIcon />
                      )
                    }
                  >
                    Descargar
                  </Button>
                )}
              </StyledInfo>
            </StyledCard>
          );
        })}
      </StyledRedes>
    </GridData>
  );
};

export default Redes;

const GridData = styled.div``;
const StyledRedes = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
  gap: 10px;

  > img {
    width: 100px;
  }
  > span {
    padding: 20px 50px;
  }
`;

const StyledVideo = styled.div`
  aspect-ratio: 16/9;
  flex: 1;
  flex-basis: 360px;
  @media (min-width: 1100px) {
    max-width: 400px;
  }
`;

const StyledCard = styled.div`
  display: flex;
  background-color: white;
  border-radius: 20px;
  padding: 20px;
  @media (min-width: 768px) {
    padding: 30px;
  }
  flex-wrap: wrap;
  width: 100%;
  gap: 10px 20px;
`;
const StyledInfo = styled.div`
  display: flex;
  flex: 2;
  flex-basis: 360px;
  flex-direction: column;
  gap: 10px;
  > h3 {
    font-size: 26px;
  }
`;

const StyledAnchor = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #ffcc00;
  width: max-content;
  padding: 5px 20px;
  border-radius: 5px;
  text-decoration: none;
  font-family: sans-serif;
  color: #114c97;
  margin-top: 15px;
`;
